import React, { Component } from "react";
import {
  Button,
  Modal,
  TextField,
  Fade,
  Box,
  Typography,
  CircularProgress,
  Tooltip,
} from "@mui/material";
import JoditEditor from "jodit-react";
import axios from "axios";
import BaseUrl from "../BaseUrl";
import Backdrop from "@mui/material/Backdrop";
import ClearIcon from "@mui/icons-material/Clear";
import Autocomplete from "@mui/material/Autocomplete";
import { ToastContainer, toast } from "react-toastify";
import { VariablLightSvg } from "../CommonSvgs";
const editorData = [
  {
    id: 4,
    type: "no",
    text: "Email Ai",
  },
  {
    id: 5,
    type: "no",
    text: "Unsubscribe link",
  },
  {
    id: 6,
    type: "no",
    text: "Calendly link",
  },
  {
    id: 7,
    type: "no",
    text: "Insert Image",
  },
  {
    id: 8,
    type: "no",
    text: "Insert Link",
  },
];
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid transparent",
  borderRadius: "7px",
  boxShadow: 24,
  p: 2,
  zIndex: 5000000,
};

const emojis = [
  { label: "Accusatory 👎", year: 1200 },
  { label: "Angry 😡", year: 30000 },
  { label: "Appreciative 🙌", year: 1976 },
  { label: "Assertive ☝️", year: 1987 },
  { label: "Concerned 😟", year: 1765 },
  { label: "Confident 💪", year: 1098 },
  { label: "Cooperative 🤝", year: 2020 },
  { label: "Curious 🤔", year: 2021 },
  { label: "Disapproving 😖", year: 2023 },
  { label: "Egocentric 🧐", year: 2024 },
  { label: "Empathetic 😌", year: 2024 },
  { label: "Encouraging 👍", year: 2024 },
  { label: "Enthusiastic 😀", year: 2024 },
  { label: "Excited 🤩", year: 2024 },
  { label: "Friendly 😉", year: 2024 },
  { label: "Funny 😂", year: 2024 },
  { label: "Joyful 😊", year: 2024 },
  { label: "Neutral 🙂", year: 2024 },
  { label: "Optimistic ✌️", year: 2024 },
  { label: "Regretful 😥", year: 2024 },
  { label: "Sad 🙁", year: 2024 },
  { label: "Serious 😐", year: 2024 },
  { label: "Surprised 😮", year: 2024 },
  { label: "Unasumming 🙄", year: 2024 },
  { label: "Worried 😨", year: 2024 },
];

const data = [
  { title: "Casual", year: "Default" },
  { title: "Formal", year: "Default" },
  { title: "Academic", year: "Expository" },
  { title: "Business", year: "Expository" },
  { title: "Essay", year: "Expository" },
  { title: "How-to", year: "Expository" },
  { title: "Instructions", year: "Expository" },
  { title: "Journalism", year: "Expository" },
  { title: "Legal", year: "Expository" },
  { title: "Technical", year: "Expository" },
  { title: "Anecdote", year: "Creative" },
  { title: "Biography", year: "Creative" },
  { title: "Fiction", year: "Creative" },
  { title: "Fiction", year: "Creative" },
  { title: "Poetry", year: "Creative" },
  { title: "Screenplay", year: "Creative" },
  { title: "Story", year: "Creative" },
  { title: "Advertising", year: "Persuasive" },
  { title: "Cover letter", year: "Persuasive" },
  { title: "Editorial", year: "Persuasive" },
  { title: "Marketing", year: "Persuasive" },
];
const RecipientData = [
  { title: "5-10", year: "Age range" },
  { title: "10-20", year: "Age range" },
  { title: "20-30", year: "Age range" },
  { title: "30-40", year: "Age range" },
  { title: "40-50", year: "Age range" },
  { title: "50-60", year: "Age range" },
  { title: "60-70", year: "Age range" },
  { title: "70+", year: "Age range" },
  { title: "Legal", year: "Business" },
  { title: "Accountant", year: "Business" },
  { title: "Applicant/Candidate", year: "Business" },
  { title: "Boss", year: "Business" },
  { title: "Coach", year: "Business" },
  { title: "Colleague", year: "Business" },
  { title: "Customer", year: "Business" },
  { title: "Customer Service", year: "Business" },
  { title: "Direct report", year: "Business" },
  { title: "Employee", year: "Business" },
  { title: "Journalist", year: "Business" },
  { title: "Lawyer", year: "Business" },
  { title: "Manager", year: "Business" },
  { title: "Partner", year: "Business" },
  { title: "Recruiter", year: "Business" },
  { title: "Sales lead / Prospect", year: "Business" },
  { title: "Supplier", year: "Business" },
  { title: "Tenant", year: "Business" },
  { title: "Vendor", year: "Business" },
  { title: "Banker", year: "Private" },
  { title: "Brother/Sister", year: "Private" },
  { title: "Child", year: "Private" },
  { title: "Doctor", year: "Private" },
  { title: "Friend", year: "Private" },
  { title: "Insurer", year: "Private" },
  { title: "Landlord", year: "Private" },
  { title: "Parent", year: "Private" },
  { title: "Patient", year: "Private" },
  { title: "Roommate", year: "Private" },
  { title: "Significant other", year: "Private" },
  { title: "Spouse", year: "Private" },
  { title: "Teammate", year: "Private" },
  { title: "Teenager", year: "Private" },
  { title: "Admin", year: "Education" },
  { title: "Professor", year: "Education" },
  { title: "Student", year: "Education" },
  { title: "Teacher", year: "Education" },
];
const userDetails = JSON.parse(localStorage.getItem("MailSenderuserDetails"));
var substringLength = 20;
var emailContent = "";
export class DrawerClassGoal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      content: "",
      // pos: 0,
      open: false,
      open2: false,
      open3: false,
      open4: false,
      open6: false,
      open8: false,
      insertLink: "",
      selectedVar: "",
      fallBackText: "",
      toggleDiv: false,
      selectedFolder: "",
      folderName: "",
      allUserTemplate: [],
      allTemplate: [],
      templateName: "",
      openPanels: [],
      calendlyData: [],
      subject: "",
      aMailStatus: false,
      bMailStatus: false,
      unsubscribeLink: "",
      openMuiModal: false,
      calendlyLoader: false,
      aiEmailForm: {
        topicTitle: "",
        tone: "",
        writingStyle: "",
        Recipient: "",
        Details: "",
      },
      emailAiHtmlContent: "",
      isFetching: false,
      showToast: false,
      activeAccordian: null,
      aiClickedType: 0,
      isOpen: false,
      // toneValue:'',
    };
  }

  updateContent = (value) => {
    this.props.setEmailBody(value);
    // this.setState({
    //   pos: window.getSelection().getRangeAt(0).startOffset,
    // });
  };

  buttonClick = (text, val, name) => {
    if (val === 1) {
      this.jodit.selection
        .insertHTML(`&nbsp<span class="clickable-span" style='display: inline;
    padding: 4px 14px;
    width:auto;
    justify-content: center;
    align-items: center;
    gap: 10px;border-radius: 4px;
    border: 1px solid var(--color-primary, #1C485F);
    color: var(--color-primary, #1C485F);
    text-align: center;
    font-family: Source Sans 3;
    white-space: nowrap;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    cursor:pointer;
' contenteditable="false" class="clickable-span">${text}</span>&nbsp`);
    } else {
      this.setState({ open3: false });
      this.jodit.selection.insertHTML(
        `&nbsp<a style='color:#0000FF' href="${text}" target="_blank" rel="noopener"> ${name} </a>&nbsp`
      );
    }
  };
  buttonClickImage = (image) => {
    this.jodit.selection.insertImage(image, null, null, null, null, null, null);
  };

  componentDidMount() {
    window.addEventListener("click", this.handleOutsideClick);
    // Add event listener for click events on spans within the editor
    document.addEventListener("click", this.handleSpanClick);
  }

  componentWillUnmount() {
    // Remove the event listener when the component is unmounted
    document.removeEventListener("click", this.handleSpanClick);
    window.removeEventListener("click", this.handleOutsideClick);
  }
  handleSpanClick = (event) => {
    const clickedElement = event.target;

    // Check if the clicked element is a span with the specified class
    if (clickedElement.classList.contains("clickable-span")) {
      // alert(`Clicked on "${clickedElement.innerText}"`);
      this.setState({ open: true });
      this.setState({ selectedVar: clickedElement.innerText });
      // Add your custom logic here for handling the click event
    }
  };

  getAllCalendlyData = (token, organization, reftoken, owner) => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `https://api.calendly.com/event_types?active=true&organization=${organization}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        this.setState({ calendlyLoader: false });
        this.setState({ open3: true });

        this.setState({
          calendlyData: response.data,
        });
        let data = JSON.stringify({
          url: "https://mail.goone.club/email-marketing/automation/trigger-calendly-email-lead-main",
          events: [
            "invitee.created",
            "invitee.canceled",
            "invitee_no_show.created",
          ],
          organization: organization,
          user: owner,
          scope: "organization",
          // "signing_key": "YYJYULqMncq9ksIwtFDvs_EZ7tBnK_8x8sF-caz81TU"
        });
        let config = {
          method: "post",
          maxBodyLength: Infinity,
          url: "https://api.calendly.com/webhook_subscriptions",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          data: data,
        };
        axios
          .request(config)
          .then((response) => {
            this.setState({ showToast: true });
            toast.success("web hook connected successfully", {
              autoClose: true,
              position: "top-right",
              duration: 3000,
            });
          })
          .catch((error) => {
            this.setState({ showToast: true });
            toast.error(
              "Please upgrade your calendly account to standard plan or higher",
              {
                autoClose: true,
                position: "top-right",
                duration: 3000,
              }
            );
          });
      })
      .catch((error) => {
        this.createAccessToken(reftoken, organization, owner);
      });
  };
  createAccessToken = (refToken, organization, owner) => {
    axios
      .post(
        `https://calendly.com/oauth/token?client_id=tSd93kn8R45mQN9oqWTdjuogB2sNdGmSPnkkFQ8wJFM&client_secret=QP2iUiADJkDBQzFudVSdKU_llhekpna7sNZ73lLgqRQ&refresh_token=${refToken}&grant_type=refresh_token`
      )
      .then((result) => {
        if (result.data) {
          let accData = {
            calendlyAccessToken: result.data.access_token,
          };
          axios
            .put(
              `${
                BaseUrl.baseurl
              }/email-marketing/user/update-user-calendly-access-token/${
                userDetails && userDetails.details._id
              }`,
              accData,
              {
                headers: {
                  Authorization: `Bearear ${userDetails && userDetails.token}`,
                },
              }
            )
            .then((response) => {
              if (response.data.status) {
                this.getAllCalendlyData(
                  result.data.access_token,
                  organization,
                  refToken,
                  owner
                );
              } else {
                if (response.data.tokenExpire) {
                  localStorage.removeItem("MailSenderuserDetails");
                  window.location.reload();
                }
              }
            })
            .catch((err) => console.log("Error"));
        }
      })
      .catch((err) => {
        window.location.href =
          "https://calendly.com/oauth/authorize?client_id=tSd93kn8R45mQN9oqWTdjuogB2sNdGmSPnkkFQ8wJFM&redirect_uri=https://app.coldsender.com/Calendly-verify/&response_type=code";
      });
  };
  connectCalendly = () => {
    const userDetailsFrom = JSON.parse(
      localStorage.getItem("MailSenderuserDetails")
    );
    axios
      .get(
        `${BaseUrl.baseurl}/email-marketing/user/get-user-info-by-id/${
          userDetailsFrom && userDetailsFrom.details._id
        }`,
        {
          headers: {
            Authorization: `Bearear ${
              userDetailsFrom && userDetailsFrom.token
            }`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          if (response.data.details.CalendlyAddedStatus) {
            this.getAllCalendlyData(
              response.data.details.CalendlyAccessToken,
              response.data.details.CalendlyOrganization,
              response.data.details.CalendlyRefreshToken,
              response.data.details.CalendlyOwner
            );
          } else {
            window.location.href =
              "https://calendly.com/oauth/authorize?client_id=tSd93kn8R45mQN9oqWTdjuogB2sNdGmSPnkkFQ8wJFM&redirect_uri=https://app.coldsender.com/Calendly-verify/&response_type=code";
          }
        } else {
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  };

  config = {
    readonly: false,
    events: {
      afterInit: (instance) => {
        this.jodit = instance;
      },
    },
    buttons:
      "undo,redo,font,fontsize,bold,italic,underline,ol,ul,center,justify,left,right",
    toolbarAdaptive: false,
    showCharsCounter: false,
    showXPathInStatusbar: false,
    statusbar: false,
    askBeforePasteHTML: false,
    askBeforePasteFromWord: true,
    defaultActionOnPaste: "insert_only_text",
    cleanHTML: true,
  };

  processEmailContent = () => {
    // Extract the next 10 characters
    const nextCharacters = emailContent.substring(0, substringLength);
    if (this.state.aiClickedType === 1) {
      this.props.setEmailBody(nextCharacters);
    } else if (this.state.aiClickedType === 2) {
      this.props.setEmailBodyA(nextCharacters);
    } else if (this.state.aiClickedType === 3) {
      this.props.setEmailBodyB(nextCharacters);
    }

    this.setState({
      pos: window.getSelection().getRangeAt(0).startOffset,
    });
    // Increment the substring length for the next iteration
    substringLength += 10;
    // Check if we have reached the end of the string
    if (substringLength <= emailContent.length) {
      // Schedule the next iteration after the specified delay
      setTimeout(() => this.processEmailContent(), 200);
    } else {
      console.log("Reached the end of the string. Stopping further calls.");
    }
  };

  handleAiEmailFormSubmit = (e) => {
    e.preventDefault();
    if (this.state.aiEmailForm.Recipient === "") {
      this.setState({ showToast: true });
      toast.error("Recipient filed is missing", {
        autoClose: true,
        position: "top-right",
        duration: 3000,
      });
      return;
    }

    if (this.state.aiEmailForm.tone === "") {
      this.setState({ showToast: true });
      toast.error("Tone filed is missing", {
        autoClose: true,
        position: "top-right",
        duration: 3000,
      });
      return;
    }
    if (this.state.aiEmailForm.writingStyle === "") {
      this.setState({ showToast: true });
      toast.error("Writing style filed is missing", {
        autoClose: true,
        position: "top-right",
        duration: 3000,
      });
      return;
    }
    // console.log("eamil data", this.state.aiEmailForm)
    let dynamicContent = `Generate a email content should be in html tag format containing topic to ${
      this.state.aiEmailForm.topicTitle
    }, for ${
      this.state.aiEmailForm.Recipient.title.includes("-" || "+")
        ? `Age range between ${this.state.aiEmailForm.Recipient.title} recipients`
        : this.state.aiEmailForm.Recipient.title
    }, tone is like ${
      this.state.aiEmailForm.tone.label
    }, writing style shoud be ${
      this.state.aiEmailForm.writingStyle.title
    } and ${this.state.aiEmailForm.Details} body in html`;
    this.setState({ isFetching: true });
    const api = `${BaseUrl.baseurl}/email-marketing/open-ai/generate-email-content`;
    axios
      .post(
        api,
        { content: dynamicContent },
        {
          headers: {
            Authorization: `Bearer ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          // console.log("getting the reponse==========>", response.data.details);
          this.setState({ emailAiHtmlContent: response.data.details });
          // this.setState({content:response.data.details})
          this.setState({ openMuiModal: false });
          this.setState({ isFetching: false });
          emailContent = response.data.details;
          this.processEmailContent();
        } else {
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  handleAiEmailFormOnchange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      aiEmailForm: {
        ...prevState.aiEmailForm,
        [name]: value,
      },
    }));
  };

  handleAutocompleteChange = (name, newValue) => {
    this.setState((prevState) => ({
      aiEmailForm: {
        ...prevState.aiEmailForm,
        [name]: newValue,
      },
    }));
    // console.log(`Selected ${name}:`, newValue);
  };

  muiModal = () => {
    return (
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={this.state.openMuiModal}
        onClose={() => this.setState({ openMuiModal: false })}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={this.state.openMuiModal}>
          <Box sx={style}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "12px",
              }}
            >
              <Typography
                id="transition-modal-title"
                variant="h6"
                component="h1"
                sx={{
                  fontSize: "26px",
                  fontWeight: "700",
                  lineHeight: "20px",
                  color: "#4B4B4B",
                }}
              >
                AI Email Writer
              </Typography>
              <Button
                disableRipple
                disableElevation
                sx={{
                  display: "flex",
                  outline: "none !important",
                  justifyContent: "flex-end",
                  padding: "0px",
                  "&:hover": {
                    background: "transparent !important",
                  },
                }}
                onClick={() => this.setState({ openMuiModal: false })}
              >
                <span className="sr-only">Close</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9.16992 14.8299L14.8299 9.16992"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M14.8299 14.8299L9.16992 9.16992"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </Button>
            </Box>
            <form
              onSubmit={this.handleAiEmailFormSubmit}
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              <div
                style={{ display: "flex", flexDirection: "column", gap: "4px" }}
              >
                <label
                  htmlFor="email-content"
                  style={{
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#4B4B4B",
                  }}
                >
                  Email topic (200 chars max)
                </label>
                <input
                  value={this.state.aiEmailForm.topicTitle}
                  name="topicTitle"
                  onChange={this.handleAiEmailFormOnchange}
                  id="email-content"
                  type="text"
                  style={{
                    backgroundColor: "transparent",
                    padding: "8px 12px",
                    borderRadius: "4px",
                    outline: "none",
                    border: "1px solid #1C485F",
                  }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "6px",
                  width: "100%",
                }}
              >
                <label
                  htmlFor="Tone"
                  style={{
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#4B4B4B",
                  }}
                >
                  Tone
                </label>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={emojis}
                  size="small"
                  sx={{ width: "100%" }}
                  value={this.state.aiEmailForm.tone || null}
                  onChange={(event, newValue) =>
                    this.handleAutocompleteChange("tone", newValue)
                  }
                  renderInput={(params) => (
                    <TextField
                      sx={{ border: "1px solid #1C485F", borderRadius: "5px" }}
                      autoComplete="off"
                      {...params}
                      label=" "
                      InputLabelProps={{ shrink: false }}
                    />
                  )}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "6px",
                  width: "100%",
                }}
              >
                <label
                  htmlFor="writing-style"
                  style={{
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#4B4B4B",
                  }}
                >
                  Writing style
                </label>
                <Autocomplete
                  id="grouped-demo"
                  value={this.state.aiEmailForm.writingStyle || null}
                  size="small"
                  onChange={(event, newValue) =>
                    this.handleAutocompleteChange("writingStyle", newValue)
                  }
                  options={data.sort((a, b) =>
                    b.year.toString().localeCompare(a.year.toString())
                  )}
                  groupBy={(option) => option.year}
                  getOptionLabel={(option) => option.title}
                  style={{ width: "100%" }}
                  renderInput={(params) => (
                    <TextField
                      sx={{ border: "1px solid #1C485F", borderRadius: "5px" }}
                      autoComplete="off"
                      {...params}
                      label=" "
                      variant="outlined"
                      InputLabelProps={{ shrink: false }}
                    />
                  )}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "6px",
                  width: "100%",
                }}
              >
                <label
                  htmlFor="writing-style"
                  style={{
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#4B4B4B",
                  }}
                >
                  Recipient
                </label>
                <Autocomplete
                  id="grouped-demo"
                  value={this.state.aiEmailForm.Recipient || null}
                  size="small"
                  onChange={(event, newValue) =>
                    this.handleAutocompleteChange("Recipient", newValue)
                  }
                  options={RecipientData.sort((a, b) =>
                    b.year.toString().localeCompare(a.year.toString())
                  )}
                  groupBy={(option) => option.year}
                  getOptionLabel={(option) => option.title}
                  style={{ width: "100%" }}
                  renderInput={(params) => (
                    <TextField
                      sx={{ border: "1px solid #1C485F", borderRadius: "5px" }}
                      autoComplete="off"
                      {...params}
                      label=" "
                      variant="outlined"
                      InputLabelProps={{ shrink: false }}
                    />
                  )}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "6px",
                  width: "100%",
                }}
              >
                <label
                  htmlFor="Details"
                  style={{
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#4B4B4B",
                  }}
                >
                  Details (optional - 600 chars max)
                </label>
                <input
                  type="text"
                  id="Details"
                  value={this.state.aiEmailForm.Details}
                  name="Details"
                  onChange={this.handleAiEmailFormOnchange}
                  style={{
                    padding: "8px 12px",
                    backgroundColor: "transparent",
                    borderRadius: "4px",
                    outline: "none",
                    border: "1px solid #DDD",
                    border: "1px solid #1C485F",
                  }}
                  placeholder="Enter additional details you want to include"
                />
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  paddingTop: "12px",
                  gap: "13px",
                }}
              >
                <button
                  style={{
                    border: "1px solid #1C485F",
                    outline: "none",
                    color: "#1C485F",
                    padding: "9px 16px",
                    fontSize: "14px",
                    fontWeight: "400",
                    borderRadius: "4px",
                  }}
                  onClick={() => this.setState({ openMuiModal: false })}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  style={{
                    textTransform: "none",
                    background: "#FF3301",
                    outline: "none",
                    color: "#fff",
                    padding: "10px 26px",
                    fontSize: "14px",
                    fontWeight: "400",
                    borderRadius: "6px",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  {this.state.isFetching && (
                    <CircularProgress
                      size={15}
                      style={{
                        color: "#FFF",
                      }}
                    />
                  )}
                  Add
                </button>
              </div>
            </form>
          </Box>
        </Fade>
      </Modal>
    );
  };
  toggleDropdown = () => {
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen,
    }));
  };

  closeDropdown = () => {
    this.setState({
      isOpen: false,
    });
  };
  handleOutsideClick = (event) => {
    if (this.dropdownRef && !this.dropdownRef.contains(event.target)) {
      this.closeDropdown();
    }
  };
  handleFileUpload = (event) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onload = (e) => {
        const base64Result = e.target.result;
        // Now you can use the base64Result as needed
        this.buttonClickImage(base64Result);
        // You may want to set the base64 result to the state or perform other actions.
      };

      // Read the file as base64
      reader.readAsDataURL(file);
    }
  };
  triggerFileInput = () => {
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = "image/*"; // Allow only image files
    fileInput.style.display = "none";

    // Attach an event listener to the file input to handle the file selection
    fileInput.addEventListener("change", this.handleFileUpload);

    // Trigger a click event on the file input to open the file selection dialog
    fileInput.click();
  };

  editorDataClick = (id) => {
    if (id === 4) {
      this.setState({ openMuiModal: true });
      this.setState({ open3: false });
      this.setState({ open4: false });
      this.setState({ open8: false });
      this.setState({ aiClickedType: 1 });
    } else if (id === 6) {
      this.setState({ calendlyLoader: true });
      this.connectCalendly();
      this.setState({ openMuiModal: false });
      this.setState({ open4: false });
      this.setState({ open8: false });
    } else if (id === 5) {
      this.setState({ open4: true });
      this.setState({ openMuiModal: false });
      this.setState({ open3: false });
      this.setState({ open8: false });
    } else if (id === 8) {
      this.setState({ open8: true });
      this.setState({ openMuiModal: false });
      this.setState({ open3: false });
      this.setState({ open4: false });
    } else if (id === 7) {
      this.triggerFileInput();
      this.setState({ open8: false });
      this.setState({ openMuiModal: false });
      this.setState({ open3: false });
      this.setState({ open4: false });
    }
  };

  sendEmailToContact = () => {
    let sendEmail = {
      FromEmail: {
        FromEmail: this.props.senderName.FromEmail,
        TokenExpiryDate: this.props.tokenExpiration,
        AccessToken:this.props.AccessToken,
        RefreshToken:this.props.refreshToken,
        FromName: this.props.senderName.FromName,
        Password: this.props.senderName.Password,
        Service: this.props.senderName.Service,
        ServiceName: this.props.senderName.ServiceName,
        Code: this.props.senderName.Code,
        Port: this.props.senderName.Port,
        Host: this.props.senderName.Host,
        ImapUsername: this.props.senderName.ImapUsername,
        ImapPassword: this.props.senderName.ImapPassword,
        ImapHost: this.props.senderName.ImapHost,
        ImapPort: this.props.senderName.ImapPort,
      },
      ToEmail: this.props.toEmailArray.map((val) => {
        let toemail = {
          ToEmail: val.Email,
          ToPhone: val.Contact,
          ToFirstName: val.FirstName,
          ToLastName: val.LastName,
        };
        return toemail;
      }),
      Subject: this.props.subject,
      Body: this.props.emailBody,
    };
    axios
      .post(
        `${
          BaseUrl.baseurl
        }/email-marketing/automation/send-campaign-goal-email/${
          userDetails && userDetails.details._id
        }/${this.props.campaginId}`,
        { data: JSON.stringify(sendEmail) },
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          this.setState({ showToast: true });
          toast.success(response.data.message);
        } else {
          this.setState({ showToast: true });
          toast.error(response.data.message);
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
        setTimeout(() => {
          this.props.setOpenDrawer(false);
        }, 3000);
      })
      .catch((err) => console.log("Error"));
  };
  jodit;
  setRef = (jodit) => (this.jodit = jodit);
  render() {
    const { isOpen } = this.state;
    return (
      <div
        style={{
          height: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            position: "relative",
          }}
        >
          <div
            style={{
              flexGrow: 1,
              display: "flex",
              flexDirection: "column",
              height: "100%",
              paddingTop:'8px'
              // padding:'8px 0px'
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "2px",
                border: "1px solid #1C485F",
                borderRadius: "6px",
                // margin: "0px 10px",
                padding: "0px 10px",
              }}
            >
              <p
                style={{
                  color: "#393939",
                  fontFamily: "Source Sans 3",
                  fontSize: "14px",
                  fontWeight: 400,
                  marginBottom: 0,
                  fontStyle: "normal",
                }}
              >
                Subject:
              </p>
              <input
                value={this.props.subject}
                onChange={(e) => {
                  this.props.setSubject(e.target.value);
                }}
                type="text"
                style={{
                  outline: "none",
                  padding: "8px",
                  flexGrow: 1,
                  backgroundColor: "transparent",
                }}
                placeholder="Enter subject here..."
              />
            </div>
            <div
              style={{
                position: "relative",
                flexGrow: 1,
                // margin: "0px 10px",
                backgroundColor: "#FFF",
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "8px",
                  alignItems: "flex-start",
                  backgroundColor: "#FFF",
                  borderRadius: "4px",
                  position: "absolute",
                  top: 0,
                  zIndex: 3000,
                  width: "100%",
                }}
              >
                <div>
                  <div ref={(ref) => (this.dropdownRef = ref)}>
                    <button
                      className="variableaddingbox"
                      onClick={this.toggleDropdown}
                      style={{padding: "10px 20px",boxShadow:
                      "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",borderRadius:'4px'}}
                    >
                      <Tooltip title="Variables will be inserted" arrow>
                      <span>
                        <VariablLightSvg />
                      </span>
                    </Tooltip>
                    </button>
                    {isOpen && (
                      <div className="dropdown-content">
                        {this.props.variableArray.map((val) => {
                          return (
                            <p
                              className="variablerowbox"
                              onClick={() => {
                                this.closeDropdown();
                                this.buttonClick(val, 1, "vig");
                              }}
                            >
                              {val}
                            </p>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "8px",
                    flexGrow: 1,
                    paddingTop: "6px",
                  }}
                >
                  {editorData.map((editor, idx) => (
                    <p
                      onClick={() => {
                        this.editorDataClick(editor.id);
                      }}
                      key={editor.id}
                      className="emailvariablesbox"
                      style={{padding: "10px 20px",}}
                    >
                      {this.state.calendlyLoader && editor.id === 6 ? (
                        <div
                          style={{
                            paddingLeft: "24x",
                            paddingRight: "24px",
                            textAlign: "center",
                          }}
                        >
                          <CircularProgress
                            size={14}
                            style={{
                              color: "#1c485f",
                              marginLeft: "32px",
                            }}
                          />
                        </div>
                      ) : (
                        editor.text
                      )}
                    </p>
                  ))}
                </div>
              </div>

              <div
                style={{
                  width: "100%",
                  position: "absolute",
                  top: 50,
                  height: "-webkit-fill-available",
                }}
              >
                <JoditEditor
                  ref={this.setRef}
                  value={this.props.emailBody}
                  config={this.config}
                  tabIndex={1} // tabIndex of textarea
                  onBlur={this.updateContent}
                  // onChange={this.updateContent}
                />
              </div>
            </div>
            <div
              style={{
                backgroundColor: "#FFF",
                width: "100%",
                marginTop:8,
                // padding: "6px 10px",
                // borderTop: "1px solid #DDD",
                zIndex: 200,
                position: "relative",
              }}
            >
              <div style={{ display: "flex", justifyContent: "flex-start" }}>
                <button
                  onClick={() => {
                    this.sendEmailToContact();
                  }}
                  style={{
                    padding: "10px 24px",
                    borderRadius: "4px",
                    color: "#fff",
                    outline: "none",
                    backgroundColor: "#FF3301",
                    alignSelf: "flex-end",
                  }}
                >
                  Send Email
                </button>
              </div>
            </div>
          </div>
          {this.state.open3 && (
            <div
              className="modalPopupDelete"
              style={{
                top: "25%",
                left: "29%",
                width: "40vw",
                borderRadius: "10px",
                background: "var(--color-white, #FFF)",
                boxShadow: "0px 2px 10px 0px rgba(25, 1, 52, 0.12)",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "16px",
                padding: "0px",
                paddingBottom: "10px",
                zIndex: 200000,
              }}
            >
              <div className="calendlymeethead">
                Available Calendly meeting{" "}
                <ClearIcon
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    this.setState({ open3: false });
                  }}
                />
              </div>

              <div className="listcalendlybos">
                {this.state.calendlyData.collection.length === 0 && (
                  <div className="subheadcalendl">
                    No Calendly Link present. Please create calendly schedule in
                    calendly site.
                  </div>
                )}

                {this.state.calendlyData.length !== 0 &&
                  this.state.calendlyData.collection.map((val) => {
                    let dmUrl = val.scheduling_url;
                    return (
                      <>
                        {val.active && (
                          <div className="calendlyboxalign">
                            <div className="insideboixcalend">
                              <div className="calendtexthead">{val.name}</div>
                              <div className="subheadcalendl">
                                {val.duration}mins /
                                {dmUrl.replace("https://calendly.com/", "")}
                              </div>
                            </div>
                            <div
                              className="inserlinkcALEND"
                              onClick={() => {
                                this.buttonClick(
                                  `${val.scheduling_url}?utm_source=userId&utm_content=node&utm_campaign=campaignId`,
                                  2,
                                  val.name
                                );
                              }}
                            >
                              Insert link
                            </div>
                          </div>
                        )}
                      </>
                    );
                  })}
              </div>
            </div>
          )}
        </div>
        <style>
          {`
                .rs-drawer-header .rs-drawer-header-close{
                    display: none;
                }
            `}
        </style>
        {this.state.openMuiModal && this.muiModal()}

        {this.state.open4 && (
          <div
            className="modalPopupDelete"
            style={{
              top: "24%",
              width: "40vw",
              left: "17%",
              borderRadius: "10px",
              background: "var(--color-white, #FFF)",
              boxShadow: "4px 4px 10px 4px #DDD",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: "16px",
              padding: "20px",
              paddingBottom: "10px",
              zIndex: 200000,
            }}
          >
            <div className="modaltext">Unsubscribe Link</div>
            <div className="modalsubtext">
              Enter the link text. This is the text that will offer your
              recipients to unsubscribe, for example: Click here to unsubscribe.
              Coldsender.com will generate and add your custom unsubscribe link to it.
            </div>
            <TextField
              autoComplete="off"
              value={this.state.unsubscribeLink}
              onChange={(e) => {
                this.setState({ unsubscribeLink: e.target.value });
              }}
              variant="standard"
              placeholder="For example: Click here to unsubscribe"
              InputProps={{
                disableUnderline: true,

                sx: {
                  display: "flex",
                  padding: "10px 16px",
                  alignItems: "center",
                  gap: "10px",
                  borderRadius: "4px",
                  border: "1px solid #1C485F",
                  background: "var(--background-color, #FAFAFA)",
                  width: "37vw",
                  "& input": {
                    color: "#868686",
                    fontFamily: "Source Sans 3",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "20px",
                  },
                },
              }}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                width: "100%",
              }}
            >
              <div
                className="cancelbuttonmodal"
                onClick={() => {
                  this.setState({ open4: false });
                }}
              >
                Cancel
              </div>
              <div
                className="continuebuttonmodal"
                style={{
                  opacity: this.state.unsubscribeLink === "" && 0.4,
                  pointerEvents: this.state.unsubscribeLink === "" && "none",
                }}
                onClick={() => {
                  this.buttonClick(
                    "https://app.coldsender.com/UnSubscribe/unsubscribemail/unsubscribecampaignid",
                    2,
                    this.state.unsubscribeLink
                  );
                  this.setState({ open4: false });
                  this.setState({ unsubscribeLink: "" });
                }}
              >
                Insert
              </div>
            </div>
          </div>
        )}
        {this.state.open8 && (
          <div
            className="modalPopupDelete"
            style={{
              top: "24%",
              width: "40vw",
              left: "25%",
              borderRadius: "10px",
              background: "var(--color-white, #FFF)",
              boxShadow: "4px 4px 10px 4px #DDD",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: "16px",
              padding: "20px",
              paddingBottom: "10px",
              zIndex: 200000,
            }}
          >
            <div className="modaltext">Insert Link</div>
            <div className="modalsubtext">
              Enter the actual URL you want to link to.
            </div>
            <TextField
              autoComplete="off"
              value={this.state.insertLink}
              onChange={(e) => {
                this.setState({ insertLink: e.target.value });
              }}
              variant="standard"
              placeholder="For example:https://coldsender.com"
              InputProps={{
                disableUnderline: true,

                sx: {
                  display: "flex",
                  padding: "10px 16px",
                  alignItems: "center",
                  gap: "10px",
                  borderRadius: "4px",
                  border: "1px solid #1C485F",
                  background: "var(--background-color, #FAFAFA)",
                  width: "37vw",
                  "& input": {
                    color: "#868686",
                    fontFamily: "Source Sans 3",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "20px",
                  },
                },
              }}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                width: "100%",
              }}
            >
              <div
                className="cancelbuttonmodal"
                onClick={() => {
                  this.setState({ open8: false });
                }}
              >
                Cancel
              </div>
              <div
                className="continuebuttonmodal"
                style={{
                  opacity: this.state.insertLink === "" && 0.4,
                  pointerEvents: this.state.insertLink === "" && "none",
                }}
                onClick={() => {
                  this.buttonClick(
                    `https://app.coldsender.com/userclicked?userLinkId=userId&campaignLinkId=campaignId&nLinkstruct=node&tolinkmail=Email&userLinkToRedirect=${this.state.insertLink}&statergyLinkClick=stratergyLink`,
                    2,
                    this.state.insertLink
                  );

                  this.setState({ open8: false });
                  this.setState({ insertLink: "" });
                }}
              >
                Insert
              </div>
            </div>
          </div>
        )}
        {this.state.open6 && (
          <Modal
            open={this.state.open6}
            onClose={() => {
              this.setState({ open6: false });
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <div
              className="modalPopupDelete"
              style={{
                top: "10%",
                left: "15%",
                width: "70vw",
                height: "80vh",
                overflowY: "scroll",
              }}
            >
              {this.props.emailBody}
            </div>
          </Modal>
        )}
       <ToastContainer />
      </div>
    );
  }
}

export default DrawerClassGoal;
